import { useTheme } from 'antd-style'

import { pretty } from '@eastcoal/common/utils/decimal'

import { FormilyProps } from '@eastcoal/formily/types/component'

export const ComplaintPenaltyText = ({ value }: FormilyProps<number>) => {
  const theme = useTheme()
  return (
    <div>
      ¥{pretty(value)}（
      <span style={{ color: theme.colorError }}>判定为违约后被扣除</span>）
    </div>
  )
}
